import { AppRoleSummary } from './approle';
import { Page } from './page';

export class SecurityLevelListing {
    id: number;
    name: string;
}

export class SecurityLevelSummary extends SecurityLevelListing {
    description: string;
    canAdd: boolean;
    canDelete: boolean;
    canEdit: boolean;
    canView: boolean;
    gridFieldAuthorization: GridFieldAuthorization[];
}

export class GridFieldAuthorization {
    id: number;
    canAdd: boolean;
    canDelete: boolean;
    canEdit: boolean;
    canView: boolean;
    defaultCanAdd: boolean;
    defaultCanDelete: boolean;
    defaultCanEdit: boolean;
    defaultCanView: boolean;
    page: Page;
    gridFieldDefinition?: any;
    appRole: AppRoleSummary;

    constructor(){
      this.canAdd = false;
      this.canEdit = true;
      this.canDelete = false;
      this.canView = true;

    }
}
